import { useState } from "react"

export const TrainingState = () => {
    const [trainingSales, setTrainingSales] = useState([])
    const [total, setTotal] = useState(0)
    const [loader, setLoader] = useState(false)
    const [trainingSaleView, setTrainingSaleView] = useState({loader: false, open: false, info: {} })
    const [filter, setFilter] = useState({training_id: '', from: '', to: '', search: ''})
    const [allTraining, setAllTraining] = useState([])
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)
    
    return {
        trainingSales: { data: trainingSales, set: setTrainingSales },
        total: { data: total, set: setTotal },
        loader: { data: loader, set: setLoader },
        trainingSaleView: { data: trainingSaleView, set: setTrainingSaleView },
        filter: { data: filter, set: setFilter },
        allTraining: { data: allTraining, set: setAllTraining },
        page: { data: page, set: setPage },
        hasMore: { data: hasMore, set: setHasMore },
    }
}